import type { IApplicationDetails } from '@/features/ApplicationForm/types';
import ApplicantInformationDetails from './ApplicantInformationDetails';
import DevelopmentSchedule from './DevelopmentSchedule';
import DevelopmentTeam from './DevelopmentTeam';
import ExperienceDetails from './ExperienceDetails';
import LeadershipInformationDetails from './LeadershipInformationDetails';
import ProjectDetails from './ProjectDetails';
import ProjectFinancial from './ProjectFinancial';

export const BakerTillyApplicationDetails = ({ applicationData, files }: IApplicationDetails) => {
  return (
    <>
      <ProjectDetails projectDetails={applicationData.projectDetails} files={files} />
      {applicationData.developmentTeam && <DevelopmentTeam developmentTeam={applicationData.developmentTeam} />}
      {applicationData.developmentSchedule && <DevelopmentSchedule developmentSchedule={applicationData.developmentSchedule} />}
      <ProjectFinancial projectFinance={applicationData.projectFinance} files={files} />
      <ApplicantInformationDetails applicantInformation={applicationData.applicantInfo} />
      <LeadershipInformationDetails leadershipInformation={applicationData.leadershipInformation} files={files} />
      <ExperienceDetails experience={applicationData.experience} />
    </>
  );
};
